<template>
  <div>
    <!-- 蒙层 -->
    <div class="notify-mask" v-if="visible"></div>

    <div class="notify-container" :class="['notify-' + type, { 'notify-show': visible }]" :style="customStyle">
      <div style="display: flex;justify-content: flex-end;">
        <i class="el-icon-close" :style="{ color: color, cursor: 'pointer' }" @click="handleClose"></i>
      </div>

      <!-- 图标 -->
      <div style="display: flex;justify-content: center;margin: 10px 0;">
        <div class="notify-icon" v-if="showIcon">
          <div v-if="type === 'success'" style="display: flex;align-items: center;">
            <i class="el-icon-circle-check" :style="{ color: color, fontSize: '20px', margin: '0 5px', }"></i>
            <span style="font-weight: 900;">{{ title }}</span>
          </div>
          <div v-if="type === 'error'" style="display: flex;align-items: center;">
            <i class="el-icon-circle-check" :style="{ color: color, fontSize: '20px', margin: '0 5px', }"></i>
            <span style="font-weight: 900;">{{ title }}</span>
          </div>
          <i v-if="type === 'warning'">!</i>
          <i v-if="type === 'info'">i</i>
        </div>
      </div>

      <!-- 内容 -->
      <div class="notify-content">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>

// 脚本部分保持不变
export default {
  name: 'Notify',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    message: {
      type: String,
      required: true,
      default: ''
    },
    type: {
      type: String,
      default: 'success'
    },
    color: {
      type: String,
      default: '#52c41a'
    },
    visible: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 3000
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    console.log('this.duration', this.duration);
    this.startTimer();
  },
  watch: {

  },
  methods: {
    startTimer() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.handleClose();
      }, this.duration);
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close', false);
      clearTimeout(this.timer);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
/* 新增蒙层样式 */
.notify-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色蒙层 */
  z-index: 9998;
  /* 确保蒙层在通知下方 */
  transition: opacity 0.3s ease;
}

.notify-container {
  position: fixed;
  width: 350px;
  height: 150px;
  padding: 12px 20px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  gap: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 9999;
  /* 确保通知在蒙层上方 */
  background-color: #fff;
  border-radius: 15px;
}

.notify-show {
  opacity: 1;
  transform: translateY(0);
}

.notify-icon {
  font-weight: bold;
  color: #000;
  font-size: 15px;
}

.notify-content {
  color: gray;
  margin-top: 5px;
  display: flex;
  justify-content: center;
}
</style>